import { useDispatch } from 'react-redux';
import { setWaveTimestamp } from '../thunks/set-wave-timestamp.thunk';
import { createNoiseWave } from '../thunks/create-noise-wave.thunk';
import { useStrip } from '../../plot/hooks/useStrip';

export const useNoiseHandler = () => {
  const dispatch = useDispatch();
  const { leads } = useStrip();

  return (eventType: keyof WindowEventMap, timestamp: number) => {
    switch (eventType) {
      case 'click':
        dispatch(createNoiseWave(timestamp, leads));
        break;

      case 'mousemove':
        dispatch(setWaveTimestamp(timestamp));
        break;
    }
  };
};
